import {action, makeObservable, observable} from 'mobx';

import {
  IMCChannelAuthFlowResponse,
  IMCChannelShownFields,
  IMCCreateChannelResponse,
  MCChannelAuthFlow,
  MCCreateChannel,
  MCCreateChannelResponse,
  SignalAuthorization,
  SignalChannelState,
  entities,
} from '../../../../api/proto';
import Channel from '../../Channel';
import ChannelsStore from '../../ChannelsStore';

export class Signal {
  constructor(public channels: ChannelsStore) {
    makeObservable(this);
  }

  @observable loading = false;
  @observable processingRequest: MCCreateChannel | null = null;

  @action protected setLoading = (loading: boolean) => {
    this.loading = loading;
  };

  @action protected setProcessingRequest_ = (processingRequest: MCCreateChannel | null) => {
    this.loading = !!processingRequest;
    this.processingRequest = processingRequest;
  };

  public createChannel = async (shownFields?: IMCChannelShownFields | null) => {
    console.debug('Signal.createChannel', shownFields);
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    const createChannel = new MCCreateChannel({
      type: entities.OzekonChannelType.OIT_SIGNAL,
      shownFields,
      signalAuthFlow: new SignalAuthorization({auth: true}),
    });

    this.setProcessingRequest_(createChannel);
    const {error, res} = await this.channels.channelsRequest<IMCCreateChannelResponse>(
      {
        createChannel,
      },
      'createChannel',
    );
    this.setProcessingRequest_(null);

    if (error) {
      return {error, res};
    }

    let channel: Channel | null = null;
    if (res) {
      channel = new Channel(
        {
          channelID: res?.channelID,
          shownFields,
          type: entities.OzekonChannelType.OIT_SIGNAL,
          workspaceID: this.channels.workspace.id,
          state: {
            signal: {
              state: SignalChannelState.State.CREATE_CHANNEL,
            },
          }
        },
        this.channels.workspace,
      );
      this.channels.workspace.app.anal.channelSetupEvent(channel);
    }

    this.processCreateChannel_(res);

    return {error, res, channel};
  };

  public refreshQrCode = async (channel: Channel) => {
    console.debug('Signal.refreshQrCode', channel?.uuid);
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    this.setLoading(true);
    const {error, res} = await this.channels.channelsRequest<IMCChannelAuthFlowResponse>(
      {
        authFlow: new MCChannelAuthFlow({
          channelID: channel.id,
          signalAuthFlow: new SignalAuthorization({auth: true}),
        }),
      },
      'authFlow',
    );
    this.setLoading(false);

    if (error) {
      return {error, res: null};
    }

    return {error: null, res: res?.signalAuthFlow};
  };

  private processCreateChannel_ = async (createChannel?: IMCCreateChannelResponse | null) => {
    if (createChannel?.result !== MCCreateChannelResponse.Result.R_INTERNAL_SERVER_ERROR) {
      await this.channels.load();
      await this.channels.workspace.refreshMembers();
    }
  };
}

export default Signal;